import React, { Component } from "react";
import COUNTIES from "../../shared/data/Counties";
import SearchTypeNavigation from "../../shared/utilities/SearchTypeNavigation";
import { Form, Row, Col } from "react-bootstrap";
import axios from "axios";

class SearchFields extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleOptions: false,
    };
  }

  componentDidMount() {
    this.getShipYears();
  }

  toggleOptions = () => {
    this.setState({
      toggleOptions: !this.toggleOptions,
    });
  };

  getShipYears = () => {
    axios.get("api/v1/hwts/search/ship-years").then((results) => {
      this.setState({
        shipYears: results.data,
      });
    });
  };

  renderKeywordInput = (
    name,
    type,
    className = "",
    placeholder = "",
    value = ""
  ) => {
    return (
      <input
        required
        onChange={this.props.handleOnKeywordChange}
        className={className}
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
      />
    );
  };

  renderFilterInput = (name, type, className = "", value = "") => {
    return (
      <input
        onChange={this.props.onFilterChange}
        className={className}
        name={name}
        type={type}
        value={value}
      />
    );
  };

  renderFilterInput = (name, placeholder, className = "") => {
    return (
      <Form.Control
        name={name}
        placeholder={placeholder}
        value={
          this.props.filters[name] !== "all" &&
          this.props.filters[name] !== "both" &&
          this.props.filters[name] !== ""
            ? this.props.filters[name]
            : ""
        }
        onChange={(e) => this.onFilterChange(e.target.name, e.target.value)}
        as="input"
        size="sm"
        custom
        onKeyPress={(e) => this.onEnterPress(e)}
      ></Form.Control>
    );
  };

  renderFilterSelect = (name, placeholder, className = "", data) => {
    return (
      <Form.Control
        name={name}
        placeholder={placeholder}
        value={
          this.props.filters[name] !== "all" &&
          this.props.filters[name] !== "both" &&
          this.props.filters[name] !== ""
            ? this.props.filters[name]
            : ""
        }
        onChange={(e) => this.onFilterChange(e.target.name, e.target.value)}
        as="select"
        size="sm"
        custom
      >
        <option value="" disabled>
          {placeholder}...
        </option>
        {data.map((d, i) => (
          <option key={d.value} value={d.value}>
            {d.name}
          </option>
        ))}
      </Form.Control>
    );
  };

  onFilterChange = (name, value) => {
    var object = {
      target: {
        name: name,
        value: value,
      },
    };
    this.props.onFilterChange(object);
  };

  onEnterPress = (e) => {
    if (e.charCode == 13) {
      this.props.handleOnSubmit(e);
    }
  };

  render() {
    const sortOptions = [
      { name: "All", value: "all" },
      { name: "ID Number", value: "epa_id" },
      { name: "Facility Name", value: "facility" },
    ];

    const faciltyStatus = [
      { name: "Active/Inactive", value: "both" },
      { name: "Active", value: "true" },
      { name: "Inactive", value: "false" },
    ];

    const manifestType = [
      { name: "All", value: "all" },
      { name: "Generator", value: "generator" },
      { name: "Transporter", value: "transporter" },
      { name: "TSDF", value: "tsdf" },
    ];

    return (
      <div>
        <div className="section section-search collapsed">
          <div className="m-l-md">
            <div className="form-inline">
              <SearchTypeNavigation />
              <div
                className="m-l-sm m-r-md"
                style={{ minWidth: "400px", width: "calc(100% - 600px)" }}
              >
                <form
                  className="agency-form"
                  onSubmit={this.props.handleOnSubmit}
                  style={{ marginTop: "2px !important" }}
                >
                  <div className="textfield-container">
                    {/* <div className="textfield-container row">
                    <div className="m-l-md m-r-sm">
                      <Form.Control
                        name="shipYear"
                        placeholder="Year..."
                        value={this.props.filters.shipYear}
                        onChange={(e) => this.onFilterChange(e.target.name, e.target.value)}
                        as="select"
                        size="md"
                        custom
                      >
                        <option value="" disabled>
                          Year...
                        </option>
                        {this.state.shipYears ? this.state.shipYears.map((d, i) => (
                          <option key={d.value} value={d.value}>
                            {d.name}
                          </option>
                        )) : []}
                      </Form.Control>
                    </div>
                    <div style={{ width: 'calc(100% - 114px)' }}> */}
                    {this.renderKeywordInput(
                      "keyword",
                      "text",
                      "search-textfield",
                      "Enter an EPAID or Manifest Tracking Number",
                      this.props.keyword
                    )}
                    {/* </div> */}
                  </div>

                  <div className="submit-container">
                    <button type="submit">
                      <span className="ca-gov-icon-search formearch">
                        <span className="sr-only">Search</span>
                      </span>
                    </button>
                  </div>
                </form>
              </div>
              <div className="">
                <a
                  href="#agencyFilters"
                  className="btn btn-secondary filter-toggle toggle-more m-y btn-block-xs"
                  role="tab"
                  data-toggle="collapse"
                  data-parent="#agencyFilters"
                  aria-expanded="false"
                  aria-controls="agencyFilters"
                  aria-selected="false"
                  id="ui-collapse-163"
                  tabIndex="-1"
                >
                  <span className="toggle-more" aria-expanded="false">
                    Advanced Filters
                    <span className="ca-gov-icon-filter" aria-hidden="true" />
                  </span>
                </a>
              </div>
            </div>
            <div
              className="collapse agencyFilters filter-group m-b-sm"
              id="agencyFilters"
              role="tabpanel"
              aria-multiselectable="true"
              //tabIndex="-1"
              aria-labelledby="ui-collapse-163"
              aria-hidden="true"
              style={{ border: "none" }}
            >
              <Form onSubmit={this.props.handleOnSubmit}>
                <div className="form-group">
                  <div className="search-filters row m-l-0 m-r-0">
                    <div className="row m-l-0 m-r-md">
                      <div className="m-r-sm">
                        {this.renderFilterSelect(
                          "type",
                          "Search only by",
                          "search-filter-control",
                          sortOptions
                        )}
                      </div>
                      <div className="m-r-sm">
                        {this.renderFilterSelect(
                          "manifestType",
                          "Handler Type",
                          "search-filter-control",
                          manifestType,
                          ""
                        )}
                      </div>
                      <div className="m-r-sm">
                        {this.renderFilterSelect(
                          "active",
                          "Status",
                          "search-filter-control",
                          [
                            { name: "All", value: "both" },
                            { name: "Active", value: "true" },
                            { name: "Inactive", value: "false" },
                          ]
                        )}
                      </div>
                      {this.props.filters.type !== "epa_id" && (
                        <div className="m-r-sm search-filter-control">
                          {this.renderFilterInput(
                            "street",
                            "Street Address...",
                            ""
                          )}
                        </div>
                      )}
                      {this.props.filters.type !== "epa_id" && (
                        <div
                          className="m-r-sm search-filter-control"
                          style={{ width: "80px" }}
                        >
                          {this.renderFilterInput(
                            "zipCode",
                            "Zip Code...",
                            "search-filter-control"
                          )}
                        </div>
                      )}
                      {this.props.filters.type !== "epa_id" && (
                        <div className="m-r-sm search-filter-control">
                          {this.renderFilterInput(
                            "city",
                            "City...",
                            "search-filter-control"
                          )}
                        </div>
                      )}
                      {this.props.filters.type !== "epa_id" && (
                        <div className="m-r-sm">
                          {this.renderFilterSelect(
                            "county",
                            "County...",
                            "search-filter-control",
                            COUNTIES,
                            ""
                          )}
                        </div>
                      )}
                    </div>
                    <div className="">
                      <button
                        className="btn btn-primary m-r-sm search-filter-button"
                        onClick={this.props.handleOnSubmit}
                      >
                        Update
                      </button>
                      <button
                        className="btn btn-standout search-filter-button"
                        type="button"
                        onClick={this.props.resetFilters}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
                <div></div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SearchFields;
